export default __webpack_public_path__ + "static/media/icon_home_top_magnifyingglass.baeb1fd9.svg";